import {useApiAuth} from "@/composables/useApiAuth";

export default defineNuxtPlugin(async() => {
    const { user, token, refresh } = useApiAuth();

    if(user.value === null && token.value !== null) {
        await refresh();
    }
});